import { render, staticRenderFns } from "./setGame7.vue?vue&type=template&id=e3b30fb6&"
import script from "./setGame7.vue?vue&type=script&lang=js&"
export * from "./setGame7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports